import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["instance", "answerAll", "answerLater", "instanceHeader"]
  static values = { quantity: Number, itemId: String }

  connect() {
    // Apply initial state
    if (this.hasAnswerAllTarget && this.answerAllTarget.checked) {
      this.hideExtraInstances()
    }
    if (this.hasAnswerLaterTarget && this.answerLaterTarget.checked) {
      this.disableAllValidation()
    }
  }

  answerAllChanged(event) {
    if (event.target.checked) {
      this.hideExtraInstances()
    } else {
      this.showAllInstances()
    }
  }

  answerLaterChanged(event) {
    if (event.target.checked) {
      this.disableAllValidation()
    } else {
      this.enableAllValidation()
    }
  }

  hideExtraInstances() {
    // Hide all instances and headers after the first one per survey
    const quantity = this.quantityValue
    this.instanceTargets.forEach((instance, index) => {
      const instanceIndex = parseInt(instance.dataset.instanceIndex)
      // Keep the first instance of each survey (index % quantity === 0)
      const isFirst = instanceIndex % quantity === 0
      instance.closest('.survey-instance-wrapper').classList.toggle('d-none', !isFirst)
      // Remove required from hidden instances so form validation passes
      if (!isFirst) {
        instance.querySelectorAll('[required]').forEach(el => {
          el.dataset.wasRequired = 'true'
          el.removeAttribute('required')
        })
      }
    })
    this.instanceHeaderTargets.forEach((header, index) => {
      // Hide all headers when answer-all is checked (only one form visible)
      header.classList.add('d-none')
    })
  }

  showAllInstances() {
    this.instanceTargets.forEach(instance => {
      instance.closest('.survey-instance-wrapper').classList.remove('d-none')
      // Restore required attributes
      instance.querySelectorAll('[data-was-required]').forEach(el => {
        el.setAttribute('required', '')
        delete el.dataset.wasRequired
      })
    })
    this.instanceHeaderTargets.forEach(header => {
      header.classList.remove('d-none')
    })
  }

  disableAllValidation() {
    this.instanceTargets.forEach(instance => {
      instance.closest('.survey-instance-wrapper').classList.add('answer-later-active')
      instance.querySelectorAll('[required]').forEach(el => {
        el.dataset.wasRequired = 'true'
        el.removeAttribute('required')
      })
    })
  }

  enableAllValidation() {
    this.instanceTargets.forEach(instance => {
      instance.closest('.survey-instance-wrapper').classList.remove('answer-later-active')
      instance.querySelectorAll('[data-was-required]').forEach(el => {
        // Only restore if the instance is visible (not hidden by answer-all)
        if (!instance.closest('.survey-instance-wrapper').classList.contains('d-none')) {
          el.setAttribute('required', '')
        }
        delete el.dataset.wasRequired
      })
    })
  }
}
